const coreWalletVatTypesForSelection = [
	'None',
	'Low',
	'High'
].map(key => {
	return { id: key, name: key };
});

export {
	coreWalletVatTypesForSelection
};
